import { useSnackbar } from "notistack";
import { GetAnswerUseCase } from "../../../../domain/usecase/answer/get/GetUseCase";
import { useEffect, useState } from "react";
import { Answer } from "../../../../domain/model/Question";
import { State } from "../../../../domain/model/ResponseState";

export function QRCodeAnswersViewModel(
  answerId: string | undefined,
  getAnswerUseCase: GetAnswerUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [answer, setAnswer] = useState<Answer | undefined>();

  useEffect(() => {
    getAnswer();
  }, []);

  async function getAnswer() {
    if (!answerId) return;
    setLoading(true);
    const response = await getAnswerUseCase.invoke(answerId);
    setLoading(false);
    switch (response.responseState) {
      case State.Success:
        setAnswer(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return { answer, loading };
}
